export default {
  inject: ['load'],
  data() {
    return {
      allPermissions: [],
    };
  },
  methods: {
    getAllPermissions: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPermissions').then(() => {
        if (this.$store.state.permissionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allPermissions = this.$store.state.permissionModule.allPermissions;
          if (this.$route.name == 'addUser') {
            this.definePermissions(this.allPermissions);
          } else if (this.$route.name == 'user') {
            this.allUserPermissions = this.allPermissions;
            this.readyUserPermission();
          } else if (this.$route.name == 'userGroup') {
            this.allUserGroupPermissions = this.allPermissions;
            this.readyUserGroupPermission();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.permissionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.permissionModule.successFlag) {
                this.getAllPermissions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.permissionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllPermissions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.permissionModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
